import { MultiSuggestSegmentEnum } from '@lp/features/MultiSuggest/types';

export const SEGMENT_NAME_MAP: Record<MultiSuggestSegmentEnum, string> = {
  [MultiSuggestSegmentEnum.EmptyToDH]: 'Empty to Donor',
  [MultiSuggestSegmentEnum.EmptyToTX]: 'Empty to Recipient',
  [MultiSuggestSegmentEnum.EmptyToAviaHub]: 'Empty to Hub Repo',
  [MultiSuggestSegmentEnum.TeamToDH]: 'Team to Donor',
  [MultiSuggestSegmentEnum.DHToTX]: 'Donor to Recipient',
  [MultiSuggestSegmentEnum.TeamToHub]: 'Team to Hub',
  [MultiSuggestSegmentEnum.DeviceToHub]: 'Device to Hub',
  [MultiSuggestSegmentEnum.Accommodation]: 'Accommodation',
};
